/**
 * Creates a URL path for a given page name or slugged route.
 * Handles the root path for 'Landing' and prepends '/' otherwise.
 * Works with nested paths (e.g. 'games/elden-ring') and query parameters.
 * @param {string} pageName - Route fragment such as "Games", "games/elden-ring" or "News?mainTag=jrpg".
 * @returns {string} The normalized URL path (always starting with '/').
 */
export function createPageUrl(pageName) {
  if (!pageName) {
    return '/';
  }
  if (pageName.toLowerCase() === 'landing') {
    return '/';
  }
  return pageName.startsWith('/') ? pageName : `/${pageName}`;
}
